var map = {
	"./BA-logo.png": "c58a",
	"./Binance.png": "b636",
	"./EU.png": "6ab6",
	"./arrow-down-up.png": "59b6",
	"./arrow-down.png": "a284",
	"./arrow-up-down-white.png": "80e9",
	"./arrow-up-down.png": "169b",
	"./arrow-up.png": "f3a8",
	"./bell.png": "6d0d",
	"./binance-futures.png": "0769",
	"./binance-logo.png": "953c",
	"./bitcoin.png": "d706",
	"./bitget_futures-logo.png": "e9e8",
	"./bitvavo-logo-landing.png": "c608",
	"./bitvavo-logo.png": "499d",
	"./bitvavo.png": "98b0",
	"./bots/PowerofPIMultiCoin2.png": "5d54",
	"./bots/TopsandBottoms.png": "9259",
	"./bots/bot_template.png": "8e9a",
	"./bronze-icon.png": "9e15",
	"./bronze.png": "8d31",
	"./bybit_futures-logo.png": "96ea",
	"./cart.png": "41b9",
	"./charging-circle.png": "ef8f",
	"./computer.png": "6333",
	"./copy.png": "78a3",
	"./dark.png": "03aa",
	"./delete.png": "ed3a",
	"./dots.png": "4eca",
	"./drawdown-tooltip.png": "cd01",
	"./edit-white.png": "f113",
	"./edit.png": "aa93",
	"./exchangeTutorials/binance/apiKeys/image.png": "6160",
	"./exchangeTutorials/binance/apiKeys/step1.png": "f95e",
	"./exchangeTutorials/binance/apiKeys/step2.png": "786f",
	"./exchangeTutorials/binance/apiKeys/step3.png": "da06",
	"./exchangeTutorials/binance/apiKeys/step4.png": "3a24",
	"./exchangeTutorials/binance/apiKeys/step5.png": "dedf",
	"./exchangeTutorials/binance/apiKeys/step6.png": "695d",
	"./exchangeTutorials/binance/apiKeys/step7.png": "65fc",
	"./exchangeTutorials/bitget/main_acc.png": "aa38",
	"./exchangeTutorials/bitget/sub_acc.png": "375a",
	"./exchangeTutorials/bitvavo/apiKeys/step1.png": "0c94",
	"./exchangeTutorials/bitvavo/apiKeys/step2.png": "7029",
	"./exchangeTutorials/bitvavo/apiKeys/step3.png": "8bcb",
	"./exchangeTutorials/bitvavo/apiKeys/step4.png": "6ee9d",
	"./exchangeTutorials/bitvavo/apiKeys/step5.png": "e965",
	"./exchangeTutorials/bitvavo/apiKeys/step6.png": "28b0",
	"./exchangeTutorials/bybit/apiKeys/step1.png": "6f29",
	"./exchangeTutorials/bybit/apiKeys/step2.png": "5137",
	"./exchangeTutorials/bybit/apiKeys/step3.png": "7c05",
	"./exchangeTutorials/bybit/apiKeys/step4.png": "6ccf",
	"./exchangeTutorials/bybit/apiKeys/step5.png": "1fbb",
	"./exchangeTutorials/bybit/createAPIKeys/step1.png": "c3a5",
	"./exchangeTutorials/bybit/createAPIKeys/step2.png": "85c0",
	"./exchangeTutorials/bybit/createAPIKeys/step3.png": "bcbd",
	"./exchangeTutorials/bybit/createAPIKeys/step4.png": "0ec5",
	"./exchangeTutorials/bybit/createAPIKeys/step5.png": "7abd",
	"./exchangeTutorials/bybit/createAPIKeys/step6.png": "baf6",
	"./exchangeTutorials/bybit/createFundSubAccount/step1.png": "93f3",
	"./exchangeTutorials/bybit/createFundSubAccount/step2.png": "c681",
	"./exchangeTutorials/bybit/createFundSubAccount/step3.png": "0128",
	"./exchangeTutorials/bybit/createFundSubAccount/step4.png": "f1c5",
	"./exchangeTutorials/bybit/createFundSubAccount/step5.png": "d424",
	"./exchangeTutorials/bybit/createFundSubAccount/step6.png": "3f8b",
	"./exchangeTutorials/kraken/kraken_permissions.png": "b287",
	"./exchangeTutorials/kucoin/kucoin_permissions.png": "7bfa",
	"./exchangeTutorials/okx/apiKeys/step1.png": "7ff7",
	"./exchangeTutorials/okx/apiKeys/step2.png": "1b67",
	"./exchangeTutorials/okx/apiKeys/step3.png": "d864",
	"./exchangeTutorials/okx/apiKeys/step4.png": "cd35",
	"./exchangeTutorials/okx/apiKeys/step5.png": "66c9",
	"./exchangeTutorials/okx/apiKeys/step6.png": "734d",
	"./exchangeTutorials/okx/createAPIKeys/step1.png": "2d5c",
	"./exchangeTutorials/okx/createAPIKeys/step2.png": "fd04",
	"./exchangeTutorials/okx/createAPIKeys/step3.png": "9aa6",
	"./exchangeTutorials/okx/createAPIKeys/step4.png": "a639",
	"./exchangeTutorials/okx/createAPIKeys/step5.png": "2dec",
	"./exchangeTutorials/okx/createFundSubAccount/step1.png": "0afe",
	"./exchangeTutorials/okx/createFundSubAccount/step2.png": "a1a2",
	"./exchangeTutorials/okx/createFundSubAccount/step3.png": "da22",
	"./exchangeTutorials/okx/createFundSubAccount/step4.png": "03e9",
	"./exchangeTutorials/okx/createFundSubAccount/step5.png": "b0eb",
	"./exchanges.png": "4477",
	"./expiry-icon.png": "a076",
	"./filterArrowClose-white.png": "b810",
	"./filterArrowClose.png": "f7e6",
	"./filterArrowOpen-white.png": "6c9a",
	"./filterArrowOpen.png": "cc0b",
	"./filters-white.png": "1c3f",
	"./filters.png": "1ac7",
	"./footer-logo.png": "55a4",
	"./ftx-logo-landing.png": "1d56",
	"./ftx-logo.png": "3ade",
	"./ftx.png": "62db",
	"./gold.png": "caf4",
	"./hamburger-gray.png": "bc12",
	"./hamburger-white.png": "1e4b",
	"./hamburger.png": "8b8f",
	"./icon-exchange.png": "1b07",
	"./icon.png": "555a",
	"./invested.png": "b660",
	"./kraken-white.png": "48af",
	"./kraken_futures-logo.png": "7c89",
	"./kucoin-logo.png": "13aa",
	"./landing/discord.png": "4556",
	"./landing/email.png": "4e76",
	"./landing/linkedin.png": "569e",
	"./landing/twitter.png": "28d5",
	"./landing/up-arrow-white.png": "855a",
	"./landing/up-arrow.png": "1932",
	"./light.png": "b448",
	"./magnifying-glass.png": "8892",
	"./maintenance.png": "b3d2",
	"./mastercard.png": "7e5a",
	"./notification/checked.png": "5ffc",
	"./notification/cross.png": "39da",
	"./notification/warning.png": "e78b",
	"./notificationIcons/bell.png": "7f13",
	"./notificationIcons/chart.png": "ab2f",
	"./notificationIcons/gear.png": "f885",
	"./notificationIcons/graph.png": "074f",
	"./notificationIcons/newspaper.png": "4089",
	"./notificationIcons/selected/bell-selected.png": "0a46",
	"./notificationIcons/selected/chart-selected.png": "875f",
	"./notificationIcons/selected/gear-selected.png": "1f8d",
	"./notificationIcons/selected/graph-selected.png": "3981",
	"./notificationIcons/selected/newspaper-selected.png": "7519",
	"./notificationIcons/selected/system-selected.png": "74a4",
	"./notificationIcons/system.png": "dc68",
	"./okx_futures-logo.png": "9970",
	"./pause.png": "88ae",
	"./payment-methods/bancontact.png": "376c",
	"./payment-methods/credit-card.png": "e2ad",
	"./payment-methods/giropay.png": "8247",
	"./payment-methods/ideal.png": "4c37",
	"./payment-methods/paypal.png": "e257",
	"./paypal-logo.png": "b489",
	"./percentage-return.png": "29e2",
	"./platformSideBar/bell.png": "f605",
	"./platformSideBar/dashboard.png": "dc63",
	"./platformSideBar/exchange.png": "57b9",
	"./platformSideBar/gear.png": "e575",
	"./platformSideBar/graph.png": "62c0",
	"./platformSideBar/history.png": "abcd",
	"./platformSideBar/information.png": "ee1d",
	"./platformSideBar/logout.png": "fa1b",
	"./platformSideBar/robot.png": "6ee9",
	"./platformSideBar/selected/bell-selected.png": "3028",
	"./platformSideBar/selected/dashboard-selected.png": "8425",
	"./platformSideBar/selected/exchange-selected.png": "0cf7",
	"./platformSideBar/selected/gear-selected.png": "120d",
	"./platformSideBar/selected/graph-selected.png": "1feb",
	"./platformSideBar/selected/history-selected.png": "252e",
	"./platformSideBar/selected/information-selected.png": "dcd8",
	"./platformSideBar/selected/logout.png": "107d",
	"./platformSideBar/selected/robot-selected.png": "2e11",
	"./play.png": "df84",
	"./refresh.png": "684f",
	"./reset-white.png": "b35c",
	"./return.png": "f5a4",
	"./risk-level.png": "ed5d",
	"./roe-tooltip.png": "b0c2",
	"./search-white.png": "f3b6",
	"./search.png": "bbc5",
	"./services/atom.png": "dc41",
	"./services/gears.png": "a58f",
	"./services/graph.png": "99b9",
	"./services/key.png": "ffa7",
	"./services/paper.png": "6ed2",
	"./services/support.png": "0692",
	"./settingsIcons/authentication.png": "837c",
	"./settingsIcons/bell.png": "12ab",
	"./settingsIcons/coin.png": "5159",
	"./settingsIcons/email.png": "e51b",
	"./settingsIcons/exchange.png": "66c3",
	"./settingsIcons/padlock.png": "adb3",
	"./settingsIcons/referral.png": "e45a",
	"./settingsIcons/selected/authentication-selected.png": "908b",
	"./settingsIcons/selected/bell-selected.png": "f65b",
	"./settingsIcons/selected/coin-selected.png": "33e1",
	"./settingsIcons/selected/email-selected.png": "5ae9",
	"./settingsIcons/selected/exchange-selected.png": "7b25",
	"./settingsIcons/selected/padlock-selected.png": "8fb9",
	"./settingsIcons/selected/referral-selected.png": "5953",
	"./settingsIcons/selected/subscription-selected.png": "1fb8",
	"./settingsIcons/selected/user-selected.png": "e056",
	"./settingsIcons/selected/white/authentication-selected-white.png": "9c8f",
	"./settingsIcons/selected/white/bell-selected-white.png": "bf31",
	"./settingsIcons/selected/white/coin-selected-white.png": "5773",
	"./settingsIcons/selected/white/email-selected-white.png": "8133",
	"./settingsIcons/selected/white/exchange-selected-white.png": "1f30",
	"./settingsIcons/selected/white/padlock-selected-white.png": "0b02",
	"./settingsIcons/selected/white/referral-selected-white.png": "8b45",
	"./settingsIcons/selected/white/subscription-selected-white.png": "b90d",
	"./settingsIcons/selected/white/user-selected-white.png": "37a9",
	"./settingsIcons/subscription.png": "a519",
	"./settingsIcons/user.png": "9004",
	"./sharpratio-tooltip.png": "ed0c",
	"./silver-icon.png": "6d11",
	"./silver.png": "8e3c",
	"./statistics/active-bots.png": "cae4",
	"./statistics/best-bot.png": "9dbc",
	"./statistics/coin.png": "276d",
	"./statistics/loss-trade.png": "a276",
	"./statistics/profit.png": "5b11",
	"./statistics/win-trade.png": "f8a3",
	"./technologies/chip.png": "eb8a",
	"./technologies/knowledge.png": "c7c2",
	"./technologies/neural.png": "a136",
	"./tooltip-white.png": "590f",
	"./tooltip.png": "3a71",
	"./total-return-blue.png": "9869",
	"./trade-frequency.png": "695a",
	"./trading-platform/bot-link.png": "d89f",
	"./trading-platform/bots/icontest.png": "ce74",
	"./trading-platform/drop-down-arrow.png": "665e",
	"./trading-platform/eye-white.png": "49b7",
	"./trading-platform/eye.png": "2c53",
	"./trading-platform/invested.png": "584c",
	"./trading-platform/percentage-return.png": "8f58",
	"./trading-platform/register-bg.png": "286c",
	"./trading-platform/shorts.png": "8fdd",
	"./trading-platform/status.png": "f795",
	"./trading-platform/tethericon.png": "fb1b",
	"./trading-platform/total-return.png": "a732",
	"./tradingCoins.png": "185d",
	"./user.png": "c121",
	"./visa-credit-card-icon-18.png": "a630",
	"./visa.png": "4b12",
	"./warning.png": "73f5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";